<template>
  <Transition name="fly" mode="out-in">
    <button
      v-if="showButton"
      @click="scrollToTop"
      class="scroll-to-top-btn btn btn-primary"
      aria-label="Scroll to top"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 14L12 9L17 14"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </Transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const showButton = ref(false)
const scrollThreshold = 100 // Show button after scrolling 100px (reduced for testing)

const handleScroll = () => {
  showButton.value = window.scrollY > scrollThreshold
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.scroll-to-top-btn {
  position: fixed !important;
  bottom: 1rem !important;
  right: 2rem !important;
  width: 3rem !important;
  height: 3rem !important;
  border-radius: 50% !important;
  z-index: 1000 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
}

.scroll-icon {
  width: 20px !important;
  height: 20px !important;
  flex-shrink: 0;
}

/* Fly-in from bottom / Fly-out to bottom animations */
.fly-enter-active {
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fly-leave-active {
  transition: all 0.3s cubic-bezier(0.55, 0.06, 0.68, 0.19);
}

.fly-enter-from {
  opacity: 0;
  transform: translateY(100px) scale(0.8);
}

.fly-leave-to {
  opacity: 0;
  transform: translateY(100px) scale(0.8);
}

.fly-enter-to,
.fly-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
}
</style>